import { createSlice } from "@reduxjs/toolkit";
import isEqual from "lodash.isequal";

const placeSlice = createSlice({
  name: "place",
  initialState: {
    places: [],
    highlighted_place_id: null,
    editPlaceId: null,
    viewPlaceId: null,
  },
  reducers: {
    setPlaces: (state, action) => {
      if (!isEqual(state.places, action.payload)) {
        state.places = action.payload;
      }
    },
    setHighlightedPlaceId: (state, action) => {
      state.highlighted_place_id = action.payload;
    },
    setEditPlaceId: (state, action) => {
      state.editPlaceId = action.payload;
    },
    setViewPlaceId: (state, action) => {
      state.viewPlaceId = action.payload;
    },
  },
});

export default placeSlice;
